import axios from 'axios';
import qs from 'qs';
import cookie from '../../cookieHelper/cookie';

export default function editStory(storyId, data) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/story/' + storyId;
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/x-www-form-urlencoded', // Adjusted for `qs.stringify` data
        },
    };

    return (
        axios.post(API_URL, qs.stringify(data), config)
            .then(res => {
                // console.log("res: ", res);
                return res.data;
            })
            .catch(err => {
                // console.log("err: ", err);
                return err;
            })
    );
}
